import styled from "styled-components";
import media from '~/utils/media';

export const Wrapper = styled.div`
  max-width: 600px;
  max-height: 600px;
  width: 100%;
  height: 100%;
  padding: 32px 32px 40px;
  background-color: white;
  z-index: 11;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  @media only screen and (max-width: 420px) {
    padding: 24px 24px 32px;
  }

  @media only screen and (max-width: 280px) {
    padding: 16px 16px 24px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;

  > div.input-wrap {
    flex: none;
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 0 16px 0 8px;
    margin-bottom: 16px;
    border: 1px solid #EDEDED;
    border-radius: 4px;
    box-sizing: border-box;

    input {
      width: 100%;
      height: 100%;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      margin-left: 8px;
      border: 0;
      outline: none;
      background-color: transparent;

      &:focus {
        border-color: #222222;
      }
    }
  }

  .listItem {
    padding: 16px 0;
    border-bottom: 1px solid #F5F5F5;
    cursor: pointer;

    > p {
      color: #222222;
      font-size: 14px;
      line-height: 24px;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const List = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #656565;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
`;

export const BtnWrap = styled.div`
  flex: none;
  padding-top: 32px;
  text-align: center;
`;

export const SearchArea = styled.button`
  flex: none;
  width: 120px;
  height: 56px;
  color: #222222;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;;
  border: 1px solid #DFDFDF;
  border-radius: 2px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  outline: none;
  appearance: none;

  &:disabled {
   color: rgb(174, 174, 174);
   border-color:  rgb(231, 231, 231);
   background-color: rgb(250, 250, 250);
  }
`;
